import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Lock, ArrowRight } from 'lucide-react';

const ProPaywall = ({ title, description }) => {
    return (
        <div className="relative mt-8">
            {/* L'effet de flou qui cache le faux contenu en dessous */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-50/80 to-slate-50 backdrop-blur-[4px] z-10 flex flex-col items-center justify-center pt-20 pb-10">
                
                <div className="bg-white p-8 rounded-3xl shadow-2xl border border-slate-200 max-w-lg text-center transform transition-all hover:scale-105 duration-300">
                    <div className="w-16 h-16 bg-indigo-50 rounded-full flex items-center justify-center mx-auto mb-6">
                        <Lock size={32} className="text-indigo-600" />
                    </div>
                    
                    <h3 className="text-2xl font-black text-slate-900 mb-3">
                        {title || "Outil réservé aux membres PRO"}
                    </h3>
                    
                    <p className="text-slate-500 font-medium mb-8 leading-relaxed">
                        {description || "Débloquez cet outil exclusif et bien d'autres en passant au niveau supérieur."}
                    </p>
                    
                    <Link to="/pricing" className="inline-flex w-full items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-black py-4 px-8 rounded-xl shadow-lg hover:shadow-indigo-500/30 transition-all group">
                        <Crown size={20} />
                        Voir les offres PRO
                        <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                    </Link>
                </div>

            </div>

            {/* Le faux contenu flouté pour donner envie */}
            <div className="opacity-40 select-none pointer-events-none">
                <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-slate-200 rounded-xl"></div>
                        <div>
                            <div className="w-24 h-4 bg-slate-200 rounded mb-2"></div>
                            <div className="w-32 h-3 bg-slate-100 rounded"></div>
                        </div>
                    </div>
                    <div className="w-20 h-8 bg-slate-200 rounded-lg"></div>
                </div>
                <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-slate-200 rounded-xl"></div>
                        <div>
                            <div className="w-24 h-4 bg-slate-200 rounded mb-2"></div>
                            <div className="w-32 h-3 bg-slate-100 rounded"></div>
                        </div>
                    </div>
                    <div className="w-20 h-8 bg-slate-200 rounded-lg"></div>
                </div>
                 <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-slate-200 rounded-xl"></div>
                        <div>
                            <div className="w-24 h-4 bg-slate-200 rounded mb-2"></div>
                            <div className="w-32 h-3 bg-slate-100 rounded"></div>
                        </div>
                    </div>
                    <div className="w-20 h-8 bg-slate-200 rounded-lg"></div>
                </div>
            </div>
        </div>
    );
};

export default ProPaywall;
